import TrashIcon from "../../Icons/TrashIcon";
import { useMutation } from "@tanstack/react-query";
import { DeleteFAQ } from "../../../api/FAQs/DeleteFAQ";
import { queryClient } from "../../../main";
import { toast } from "react-toastify";
const FaqRow = ({
    question,
    answer,
    video,
    faqId,
}: {
    question: string;
    answer: string;
    video?: string;
    faqId: string;
}) => {
    const { mutate: deleteFaq } = useMutation({
        mutationFn: DeleteFAQ,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["faqs"] });
            toast.success("FAQ deleted successfully");
        },
    });


    return (
        <tr>
            <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
                <div className="inline-fl rounded-full text-left py-0.5 text-sm font-semibold flex items-center gap-4">
                    {question}
                </div>
            </td>
            <td className=" px-2 first:pl-5 last:pr-5  py-3 ">
                <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold ">
                    {answer}
                </div>
            </td>
            <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
                <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold">
                    {video}
                </div>
            </td>
            <td className="px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap ">
                <div className="flex rounded-xl justify-center items-center bg-[#FAFBFD] border-[#D5D5D5] border py-3 text-sm font-semibold min-w-[50px] ml-auto text-[#EF3826]">
                    <button onClick={() => deleteFaq(faqId)}>          
                    <TrashIcon />
                    </button>
                </div>
            </td>
        </tr>
    );
};

export default FaqRow;
